import React from 'react';

export default function SEO({ title, description, canonical, jsonLd }) {
  React.useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content, isProp=false) => {
      if (!content) return;
      const attr = isProp ? 'property' : 'name';
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };
    setMeta('description', description);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', 'website', true);
    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement('link'); link.setAttribute('rel','canonical'); document.head.appendChild(link); }
      link.setAttribute('href', canonical);
    }
    // Remove any previous JSON-LD injected by SEO
    document.head.querySelectorAll('script[data-seo="1"]').forEach(s => s.remove());
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      arr.forEach(obj => {
        const s = document.createElement('script');
        s.type = 'application/ld+json';
        s.dataset.seo = '1';
        s.text = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
  }, [title, description, canonical, JSON.stringify(jsonLd)]);
  return null;
}
